export default __webpack_public_path__ + "static/media/Johns_Hopkins.30b23b85.png";